import {useState, useEffect} from "react";


const SwitcherRadioButtons = (
    {
        name,
        value, setValue,
        values = [],
        title = "",
        textStart = "textStart", textEnd = "textEnd",
        classAdd = ""
    }) => {
    const [checked, setChecked] = useState(false);
    const [hidden, setHidden] = useState(value);
    const [colorText, setColorText] = useState({
        start: "",
        end: ""
    });

    useEffect(() => {
        if (values.length) {
            if (values[0] === value) {
                setChecked(false);
                setStart();
            } else {
                setChecked(true);
                setEnd();
            }
        }

    }, [value]);

    const setEnd = () => {
        setHidden(values[1]);
        setValue(values[1]);
        setColorText({
            start: "text-disabled",
            end: ""
        });
    }
    const setStart = () => {
        setHidden(values[0]);
        setValue(values[0]);
        setColorText({
            start: "",
            end: "text-disabled"
        });
    }

    const ChangeSwitcher = (e) => {
        setChecked(e.target.checked);
        if (e.target.checked) {
            setEnd();
        } else {
            setStart();
        }
    }


    return (
        <div className={`switcher-radio-buttons ${classAdd}`}>
            <input type="hidden" name={name} id={`hidden-${name}`} value={hidden}/>
            <div className="text-center mb-2 h5">{title}</div>
            <label className={`me-4 ` + colorText.start} htmlFor={`switcher-${name}`}>{textStart}</label>
            <div className="form-check form-switch d-inline-block">
                <input className="form-check-input switch-values" type="checkbox" role="switch" id={`switcher-${name}`}
                       onChange={ChangeSwitcher} checked={checked}
                />
                <label className={`form-check-label mt-1 ` + colorText.end} htmlFor={`switcher-${name}`}>{textEnd}</label>
            </div>
        </div>
    )
}
export default SwitcherRadioButtons